import { Component, OnInit ,OnChanges, OnDestroy, Input} from '@angular/core';

import { SynergoCitationService } from '../../../service/synergo-citation/synergo-citation.service';
import { ContractService } from '../../../service/contract/contract.service';
import { Attendance } from '../../../class/attendance';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule, SelectItem, MenuItem } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { Candidate } from '../../../class/candidate';
import { config } from '../../../../../../environments/config';
import { UploadFilesService } from '../../../service/upload-files/upload-files.service';
import { CandidateService } from '../../../service/candidate/candidate.service';
import { AttendanceJustificationService } from '../../../service/attendance-justification/attendance-justification.service';
import { CustomerGuideService } from '../../../service/customer-guide/customer-guide.service';
import { DocumentProfileSurveyService } from '../../../service/document-profile-survey/document-profile-survey.service';
import { values } from 'lodash';
import { Reset } from '@ngrx/store-devtools/src/actions';
import { formatDate } from '../../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-synergo-citations',
  templateUrl: './synergo-citations.component.html',
  styleUrls: ['./synergo-citations.component.scss']
})
export class SynergoCitationsComponent implements OnInit, OnDestroy {

  @Input() identification_number: string;
  @Input() only_attended: boolean;

  public promiseForm: Promise<any>;

  public msgs: Message[] = [];
  public citations: Attendance[];
  public recruits: Attendance[];
  public selectCitation: Attendance;
  public CitationID: Number = 0;
  public modNew = false;
  public modView = false;
  public openCitation = false;
  public totalRecords: number;
  public page: number;
  public per_page: number;
  public sort: string;

  public per_page_documentation: number;

  public modViewDialog: boolean;
  public citationEditCitation: any;
  public idEditRequisition: number;
  public idEditCitation: number;
  public statusEditCitation: string;
  public typeEditCitation: string;
  public displaySidebarJustification: boolean;

  public form2: FormGroup;
  public justification: AbstractControl;
  public listCitationJustification: any[];
  public informationCustomerGuide: any[];
  edit1: Attendance;

  public form3: FormGroup;
  public company_id_filter: AbstractControl;
  public candidate_id_filter: AbstractControl;
  public recruited_by_id_filter: AbstractControl;
  public interviewed_by_id_filter: AbstractControl;
  public documental_analysis_by_id_filter: AbstractControl;
  public hire_by_id_filter: AbstractControl;
  public start_admission_date_filter: AbstractControl;
  public end_admission_date_filter: AbstractControl;
  public start_date_medical_appointment_filter: AbstractControl;
  public end_date_medical_appointment_filter: AbstractControl;
  public venue_id_filter: AbstractControl;
  public send_customer_filter: AbstractControl;
  public sendcustomerOptions: SelectItem[];
  public send_hiring_filter: AbstractControl;
  public manager_send_hiring_sign_by_id_filter: AbstractControl;
  public sendhiringOptions: SelectItem[];
  public status_medical_examen_filter: AbstractControl;
  public statusMedicalExamenOptions: SelectItem[];
  public send_hiring_sign_filter: AbstractControl;
  public sendHiringSignOptions: SelectItem[];
  public send_documental_management_filter: AbstractControl;
  public sendDocumentalManagementOptions: SelectItem[];
  public result_documental_analysis_filter: AbstractControl;
  public resultDocumentalAnalysisOptions: SelectItem[];
  
  public employeePositionToLoadSelection: string;
  public employeePositionDocumentalToLoadSelection: string;
  public employeePositionHireToLoadSelection: string;

  public modExportDialog: boolean;
  public modImportDialog: boolean;
  public modRecruitmentDialog: boolean;

  public form4: FormGroup;
  
  public f4_date_start: AbstractControl;
  public f4_date_end: AbstractControl;
  public f4_venue_id: AbstractControl;
  public f4_company_id: AbstractControl;
  public f4_status_filter: AbstractControl;
  public f4_export_type_filter: AbstractControl;
  
  public form5: FormGroup;
  public mobile_send: AbstractControl;
  public message_send: AbstractControl;

  public apiUrl = config.API_ROOT;

  public params_id_requisition: number;

  public viewType: string;

  public lists: any;

  public selectCandidate: Candidate;
  public modViewDialogCandidate: boolean;
  public modViewDialogWhatsapp: boolean;

  public modViewDialogDocumentation: boolean;

  public sticky: boolean;

  public reloadInterval: any;
  public loading: boolean;
  public modViewDialogExchangeCitation: boolean;
  public showbuttonExchangeCitation:boolean;

  public sortHireToday: boolean;
  public sortHire: boolean;
  public query: string;

  public first = 0;

  public statusOptions: SelectItem[];
  public result: any;
  public ReportTypeExportOptions: SelectItem[];
  public selectedReportTypeExportOptions: {label: string, value: string};
  public filters: any[];

  public es: any;

  public allinone: boolean;

  public uploadedImportFile: any[] = [];
  public prewiewImportFile: any;
  public promiseImportFile: Promise<any>;

  public candidate: Candidate[];

  public uploadedAttachment: any[] = [];
  public prewiewFileAttachment: any[] = [];
  public promiseAttachment: Promise<any>;
  public listDocuments: any[] = [];
  public selectCitationType: string;
  public loading_upload: boolean;
  public requisitionTrasnfer: any;
  public selectCitationsTransf: any[];
  public resultSelectCitationsTransf: any[];
  public lengthresultSelectCitationsTransf:number;
  
  public editPart;
  public editEventPart;

  public form6: FormGroup;
  public requisition_id_transfer: AbstractControl;
  public showrequisitionTransfer: boolean;
  public showrequisitionTransferClose: boolean;
  public requisitionTrasnferOk : boolean;
  public loadingShowTransfReq: boolean;

  public modViewDialogUploadCitationExc: boolean;
  public citationsUploadResult: any;
  public citationsUploadResultStatus : number=0;
  public lengthCitationsUploadResult : number=0;
  
  public listDocumentsHV: any[] = [];
  public copyHV: boolean= false;

  public gestSignHireDialog: boolean = false;
  public employeeSelected: string;

  public form7: FormGroup;
  public date_medical_appointment: AbstractControl;
  public lab_medical_exams: AbstractControl;

  public getMedicalAppointmentLaboratoryDialog: boolean = false;

  public form8: FormGroup;
  public instruction: AbstractControl;
  
  constructor(
      public synergocitationService: SynergoCitationService,
      public confirmationService: ConfirmationService,
      public translate: TranslateService,
      public activatedRoute: ActivatedRoute,
      public hasPermissionService: HasPermissionService,
      public fb: FormBuilder,
      private notificationsService: NotificationsService,
      public uploadFilesService: UploadFilesService,
      public candidateService: CandidateService,
      public attendanceJustificationService: AttendanceJustificationService,
      public contractService: ContractService,
      public customerGuideService: CustomerGuideService,
      public documentProfileSurveyService: DocumentProfileSurveyService,
          ) {
              this.es = calendarES();

              this.modViewDialogCandidate = false;
              this.modViewDialogWhatsapp = false;
              this.viewType = 'list';

              this.modViewDialogDocumentation = false;
              this.displaySidebarJustification = false;
              this.ReportTypeExportOptions = [
                  {label: 'Reporte Citación - General', value: 'Reporte Citación - General'},
                  {label: 'Reporte Citación - Contratado Por', value: 'Reporte Citación - Contratado Por'},
                  {label: 'Reporte Citación - Contratado Diario', value: 'Reporte Citación - Contratado Diario'},
                  {label: 'Reporte Citación - Reclutamiento', value: 'Reporte Citación - Reclutamiento'},
                  {label: 'Reporte Citación - Documentación', value: 'Reporte Citación - Documentación'},
                  {label: 'Reporte Citación - Contratado por Fecha Ingreso', value: 'Reporte Citación - Contratado por Fecha Ingreso'},
                  {label: 'Reporte Citación - Psicólogas', value: 'Reporte Citación - Psicólogas'},
                  {label: 'Reporte Citación - Backup Claro', value: 'Reporte Citación - Backup Claro'},
                  {label: 'Reporte Citación - Informe Documentos Contratados', value: 'Reporte Citación - Informe Documentos Contratados'},
                  {label: 'Reporte Citación - Fecha de ingreso', value: 'Reporte Citación - Fecha de ingreso'}
              ];
              this.sendcustomerOptions=[
                  {label: 'Todos Enviado al cliente', value: ""},
                  {label: 'Enviado al cliente', value: 'Favorable'},
                  {label: 'No enviado al cliente', value: 'null'}
              ];
              this.sendhiringOptions=[
                  {label: 'Todos Enviado contratación', value: ''},
                  {label: 'Sí', value: 'Si'},
                  {label: 'No', value: 'No'},
                  {label: 'Pendiente', value: 'pending'},
                  {label: 'No contratado',value: 'No contratado'}
              ];
              
              this.statusMedicalExamenOptions=[
                  {label: 'Cualquiera',value:''},
                  {label: 'Autorizado',value:'Autorizado'},
                  {label: 'No apto',value:'No apto'},
                  {label: 'Compromiso',value:'Compromiso'},
                  {label: 'Favorable',value:'Favorable'},
                  {label: 'Aplazado',value:'Aplazado'},
                  {label: 'No asistió',value:'No asistió'},
                  {label: 'Inicio',value:'Inicio'},
                  {label: 'Fin',value:'Fin'},
                  {label: 'Candidato en atención', value: 'Candidato en atención'},
                  {label: 'No ha llegado el examen médico al correo', value: 'No ha llegado el examen médico al correo'},
                  {label: 'Se esta ampliando información', value: 'Se esta ampliando información'},
                  {label: 'Pendiente cierre de historia clinica', value: 'Pendiente cierre de historia clinica'},
              ];
              
              this.sendHiringSignOptions=[
                  {label: 'Todos Gestionar contratación',value:""},
                  {label: 'Sí', value: 1},
                  {label: 'No', value: "0, "}

              ];
              this.sendDocumentalManagementOptions=[
                  {label: 'Todos Enviado Gestion Documental',value:''},
                  {label: 'Sí', value: "1"},
                  {label: 'No', value: "0"}
              ];
              this.resultDocumentalAnalysisOptions=[
                  {label: 'Todos Resultado Analisis Documental',value:''},
                  {label: 'No Apto', value: "No Apto"},
                  {label: 'Novedad', value: "Novedad"},
                  {label: 'Favorable', value: "Favorable"},
                  {label: 'Autorizado', value: "Autorizado"},
                  {label: 'Revisado', value: "Revisado"},
                  {label: 'Sin Documentos', value: "Sin Documentos"}
              ];

              this.form2 = fb.group({
                  'justification': ['', Validators.compose([Validators.required, Validators.minLength(2)])]
              });
              this.justification = this.form2.controls['justification'];
              this.form3 = fb.group({
                  'company_id_filter': [''],
                  'candidate_id_filter': [''],
                  'recruited_by_id_filter': [''],
                  'interviewed_by_id_filter': [''],
                  'documental_analysis_by_id_filter': [''],
                  'hire_by_id_filter': [''],
                  'start_admission_date_filter': [''],
                  'end_admission_date_filter': [''],
                  'start_date_medical_appointment_filter':[''],
                  'end_date_medical_appointment_filter':[],
                  'venue_id_filter': [''],
                  'send_customer_filter':[''],
                  'send_hiring_filter':[''],
                  'status_medical_examen_filter':[''],
                  'send_hiring_sign_filter':[''],
                  'send_documental_management_filter':[''],
                  'result_documental_analysis_filter':[''],
                  'manager_send_hiring_sign_by_id_filter':['']
              });
              this.company_id_filter = this.form3.controls['company_id_filter'];
              this.candidate_id_filter = this.form3.controls['candidate_id_filter'];
              this.recruited_by_id_filter = this.form3.controls['recruited_by_id_filter'];
              this.interviewed_by_id_filter = this.form3.controls['interviewed_by_id_filter'];
              this.documental_analysis_by_id_filter = this.form3.controls['documental_analysis_by_id_filter'];
              this.hire_by_id_filter = this.form3.controls['hire_by_id_filter'];
              this.start_admission_date_filter = this.form3.controls['start_admission_date_filter'];
              this.end_admission_date_filter = this.form3.controls['end_admission_date_filter'];
              this.start_date_medical_appointment_filter = this.form3.controls['start_date_medical_appointment_filter'],
              this.end_date_medical_appointment_filter = this.form3.controls['end_date_medical_appointment_filter'];
              this.venue_id_filter = this.form3.controls['venue_id_filter'];
              this.send_customer_filter= this.form3.controls['send_customer_filter'];
              this.send_hiring_filter= this.form3.controls['send_hiring_filter'];
              this.status_medical_examen_filter = this.form3.controls['status_medical_examen_filter'];
              this.send_hiring_sign_filter = this.form3.controls['send_hiring_sign_filter'];
              this.result_documental_analysis_filter = this.form3.controls['result_documental_analysis_filter'];
              this.send_documental_management_filter = this.form3.controls['send_documental_management_filter'];
              this.manager_send_hiring_sign_by_id_filter = this.form3.controls['manager_send_hiring_sign_by_id_filter'];

              this.employeePositionToLoadSelection = '5,6,38';
              this.employeePositionDocumentalToLoadSelection= '7,8';
              this.employeePositionHireToLoadSelection= '5,6,7,8,9,10,38,53';

              this.form4 = fb.group({
                  'f4_date_start': ['', [Validators.required]],
                  'f4_date_end': ['', [Validators.required]],
                  'f4_venue_id': [''],
                  'f4_company_id': [''],
                  'f4_status_filter': [''],
                  'f4_export_type_filter': [''],
              });
              this.f4_date_start = this.form4.controls['f4_date_start'];
              this.f4_date_end = this.form4.controls['f4_date_end'];
              this.f4_venue_id = this.form4.controls['f4_venue_id'];
              this.f4_company_id = this.form4.controls['f4_company_id'];
              this.f4_status_filter = this.form4.controls['f4_status_filter'];
              this.f4_status_filter.setValue('all');
              this.f4_export_type_filter = this.form4.controls['f4_export_type_filter'];

              this.form5 = fb.group({
                  'mobile_send': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
                  'message_send': ['', Validators.compose([Validators.required, Validators.minLength(2)])]
              });
              this.mobile_send = this.form5.controls['mobile_send'];
              this.message_send = this.form5.controls['message_send'];
              
              this.form6 = fb.group({
                  'requisition_id_transfer':['',Validators.compose([Validators.required,Validators.minLength(2)])]
              });
              this.requisition_id_transfer=this.form6.controls['requisition_id_transfer'];
              
              this.form7 = fb.group({
                  'date_medical_appointment':['',Validators.compose([Validators.required,Validators.minLength(2)])],
                  'lab_medical_exams':['',Validators.compose([Validators.required,Validators.minLength(2)])]
              });
              this.form8 = fb.group({
                  'instruction': ['', Validators.compose([Validators.required, Validators.minLength(2)])]
              });
              this.instruction = this.form8.controls['instruction'];
              
              this.date_medical_appointment= this.form7.controls['date_medical_appointment'];
              this.lab_medical_exams= this.form7.controls['lab_medical_exams'];
              
              this.modViewDialogUploadCitationExc = false;
              this.allinone = false;
              if (this.hasPermission('get citation allinone')) {
                  this.allinone = true;
              }

              this.modExportDialog = false;
              this.modImportDialog = false;
              this.modRecruitmentDialog = false;


              this.sticky = false;
              this.loading = true;

              this.statusOptions = [
                  {label: 'Todas', value: 'all'},
                  {label: 'Abierta', value: 'Abierto'},
                  // {label: 'En Proceso', value: 'En Proceso'},
                  {label: 'Congelado', value: 'Congelado'},
                  {label: 'Cerrada', value: 'Cerrado'},
              ];
              this.listCitationJustification = [];
              this.informationCustomerGuide = [];
              this.listDocuments = [];
              this.editPart = undefined;
              this.editEventPart = undefined;

              this.totalRecords = 0;
              this.loading_upload=false;
              this.modViewDialogExchangeCitation = false;
              this.showbuttonExchangeCitation=false;
              this.showrequisitionTransfer=false;
              this.showrequisitionTransferClose=false;
              this.requisitionTrasnferOk = false;
              this.loadingShowTransfReq= false;
              this.lengthresultSelectCitationsTransf=0;
  }

  ngOnInit() {
      this.filters = [];

      this.activatedRoute.queryParams.subscribe(params => {
          if (params['id_requisition']) {
              this.params_id_requisition = Number(params['id_requisition']);
          }
      });

      if (this.identification_number) {
          this.getCandidate(this.identification_number);
      }

      this.page = 1;
      this.per_page = 10;
      this.sort = '-id';

      this.per_page_documentation = 100;

      this.reloadInterval = setInterval(() => {
          this.filter();
       }, 240000);
  }

  public ngOnChanges() {
      if (this.only_attended) {
          this.citations = [];
          this.recruits = [];
          this.loading = true;
      }
      //this.ngOnInit();
  }

  ngOnDestroy() {
      // Will clear when component is destroyed e.g. route is navigated away from.
      clearInterval(this.reloadInterval);
  }

  public loadCitationsLazy(event: LazyLoadEvent) {
      this.page = (event.first / this.per_page) + 1;

      if (event.sortField) {
          if (event.sortOrder === -1) {
              this.sort = '-' + event.sortField;
          } else {
              this.sort = event.sortField;
          }
      } else {
          this.sort = '-start_send_hiring_sign';
      }

      if (event.globalFilter) {
          this.query = event.globalFilter;
      } else {
          this.query = undefined;
      }

      this.filter();
  }

  public getSynergoCitations() {
    this.loading = true;
    this.synergocitationService.getSynergoCitation(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
        response => {
            this.loading = false;
            this.citations = response.json().data;

            if (response.json().meta.total > response.json().meta.total_filtered) {
                this.totalRecords = response.json().meta.total_filtered;
            } else {
                this.totalRecords = response.json().meta.total;
            }
        },
        error => {
            this.loading = false;
            let msg = '';
            this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                    JSON.parse(error._body).errors.forEach(element => {
                        if (element.source) {
                            if (element.source.pointer) {
                                this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                    msg = msg + res3 + ', ';
                                });
                            }
                        }
                    });
                    this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                });
            });
        }
    );
  }

  public getSynergoCitationsByRequisitions(id: number) {
      this.loading = true;
      this.synergocitationService.getSynergoCitationByRequisition(id, this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
          response => {
              this.loading = false;
              this.citations = response.json().data;
              if (response.json().meta.total > response.json().meta.total_filtered) {
                  this.totalRecords = response.json().meta.total_filtered;
              } else {
                  this.totalRecords = response.json().meta.total;
              }
          },
          error => {
              this.loading = false;
              let msg = '';
              this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                  this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                      JSON.parse(error._body).errors.forEach(element => {
                          if (element.source) {
                              if (element.source.pointer) {
                                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                      msg = msg + res3 + ', ';
                                  });
                              }
                          }
                      });
                      this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                  });
              });
          }
      );
  }

  public newSynergoCitation() {
      this.modNew = !this.modNew;
      this.selectCitation = null;
  }

  public savedCitation(res) {
      this.msgs = [];
      this.msgs.push(res);
  }

  public cancelCitation (res) {
      this.selectCitation = null;
      this.modNew = false;
      this.modView = false;
      if (this.params_id_requisition) {
          this.getSynergoCitationsByRequisitions(this.params_id_requisition);
          // this.getRecruitsByRequisitions(this.params_id_requisition);
      } else {
          //this.getCitations();//Comentado porque existe componente y se quita y detecta load_lazy
          // this.getRecruits();
      }
      this.editPart= undefined;
      this.editEventPart= undefined;
  }

  public newRecruit() {
      this.modNew = !this.modNew;
      this.selectCitation = null;
      this.editPart= 'recruited';
      this.editEventPart= undefined;
  }

  public edit(citation: Attendance) {
      this.modNew = true;
      this.selectCitation = citation;
      if (this.params_id_requisition) {
          this.getSynergoCitationsByRequisitions(this.params_id_requisition);
          // this.getRecruitsByRequisitions(this.params_id_requisition);
      } else {
          // this.getCitations();
          // this.getRecruits();
      }
      this.editEventPart = undefined;
  }

  public view(citation: Attendance) {
      this.openCitation = true;
      this.selectCitation = citation;
      this.CitationID = citation.id;
      this.modView = true;
  }

  public deleteDialog(citation: Attendance) {
      let message;
      this.translate.get('Do you want to delete?').subscribe((res: string) => {
          message = res;
      });

      let header;
      this.translate.get('Delete Confirmation').subscribe((res: string) => {
          header = res;
      });

      this.confirmationService.confirm({
          message: message,
          header: header,
          icon: 'fa fa-trash',
          accept: () => {
              this.delete(citation);
          }
      });
  }

  public delete(citation: Attendance) {
      this.synergocitationService.deleteSynergoCitation(citation.id).toPromise().then(
          response => {
              this.msgs = [];
              this.msgs.push( { severity: 'success', summary: 'deleted' } );
              if (this.params_id_requisition) {
                  this.getSynergoCitationsByRequisitions(this.params_id_requisition);
                  // this.getRecruitsByRequisitions(this.params_id_requisition);
              } else {
                  this.getSynergoCitations();
                  // this.getRecruits();
              }
          },
          error => {
              let msg = '';
              this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                  this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                      JSON.parse(error._body).errors.forEach(element => {
                          if (element.source) {
                              if (element.source.pointer) {
                                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                      msg = msg + res3 + ', ';
                                  });
                              }
                          }
                      });
                      this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                  });
              });
          }
      );
  }

  public filterRefresh () {
      this.filter(true);
  }

  public filter (pageRefresh?) {
      if (pageRefresh) {
          this.page = 1;
          this.first = 0;
      }

      this.filters = [];
      // if (values) {

      this.filters.push({'key': 'recruited_accepted', 'value': 1});

      if (this.candidate) {
          this.filters.push({'key': 'candidate_id-in', 'value': this.candidate[0].id});
      }

      if (this.company_id_filter.value) {
          if (this.company_id_filter.value.id) {
              this.filters.push({'key': 'company_id-lk', 'value': this.company_id_filter.value.id});
          }
      }
      if (this.candidate_id_filter.value) {
          if (this.candidate_id_filter.value.id) {
              this.filters.push({'key': 'candidate_id-lk', 'value': this.candidate_id_filter.value.id});
          }
      }
      if (this.recruited_by_id_filter.value) {
          if (this.recruited_by_id_filter.value.id) {
              this.filters.push({'key': 'recruited_by_id-lk', 'value': this.recruited_by_id_filter.value.id});
          }
      }
      if (this.interviewed_by_id_filter.value) {
          if (this.interviewed_by_id_filter.value.id) {
              this.filters.push({'key': 'interviewed_by_id-lk', 'value': this.interviewed_by_id_filter.value.id});
          }
      }
      if (this.documental_analysis_by_id_filter.value) {
          if (this.documental_analysis_by_id_filter.value.id) {
              this.filters.push({'key': 'documental_analysis_by_id-lk', 'value': this.documental_analysis_by_id_filter.value.id});
          }
      }
      if (this.hire_by_id_filter.value) {
          if (this.hire_by_id_filter.value.id) {
              this.filters.push({'key': 'hire_by_id-lk', 'value': this.hire_by_id_filter.value.id});
          }
      }
      if(this.manager_send_hiring_sign_by_id_filter.value){
          if (this.manager_send_hiring_sign_by_id_filter.value.id) {
              this.filters.push({'key': 'manager_send_hiring_sign_by_id-lk', 'value': this.manager_send_hiring_sign_by_id_filter.value.id});
          }
      }
      if (this.venue_id_filter.value) {
          this.filters.push({'key': 'venue_id-lk', 'value': this.venue_id_filter.value});
      }
      if(this.send_customer_filter.value)
      {
          if(this.send_customer_filter.value=='Favorable')
              this.filters.push({'key': 'result_send_customer', 'value': 'Favorable,Autorizado'});
          else if(this.send_customer_filter.value=='null')
              this.filters.push({'key': 'result_send_customer', 'value': 'No,Favorable,Autorizado'});
          else
          this.filters.push({'key': 'result_send_customer', 'value': ''});        
      }
      if(this.send_hiring_filter.value)
      {
          if(this.send_hiring_filter.value=='Si')
              this.filters.push({'key': 'send_hiring', 'value': 'Si'});
          else if(this.send_hiring_filter.value=='pending')
              this.filters.push({'key': 'send_hiring', 'value': 'pending'});
          else if(this.send_hiring_filter.value=='No contratado')
              this.filters.push({'key': 'send_hiring', 'value': 'No contratado'});
          else if(this.send_hiring_filter.value=='No')
              this.filters.push({'key': 'send_hiring', 'value': "No,Si,pending,No contratado"});
          else
              this.filters.push({'key': 'send_hiring-in', 'value': ''});            
      }
      if(this.send_documental_management_filter.value)
      {
          if(this.send_documental_management_filter.value=="1")
              this.filters.push({'key': 'send_documental_management', 'value': "1"});
          // else if(this.send_documental_management_filter.value=='0')
          //     this.filters.push({'key': 'send_documental_management', 'value': "0"});
          else
              this.filters.push({'key': 'send_documental_management', 'value': "0"});
      }  
      if(this.result_documental_analysis_filter.value)
      {
          if(this.result_documental_analysis_filter.value=='No Apto')
              this.filters.push({'key': 'result_documental_analysis', 'value': 'No Apto'});
          else if(this.result_documental_analysis_filter.value=='Novedad')
              this.filters.push({'key': 'result_documental_analysis', 'value': 'Novedad'});
          else if(this.result_documental_analysis_filter.value=='Favorable')
              this.filters.push({'key': 'result_documental_analysis', 'value': 'Favorable'});
          else if(this.result_documental_analysis_filter.value=='Autorizado')
              this.filters.push({'key': 'result_documental_analysis', 'value': 'Autorizado'});
          else if(this.result_documental_analysis_filter.value=='Revisado')
              this.filters.push({'key': 'result_documental_analysis', 'value': 'Revisado'});
          else 
              this.filters.push({'key': 'result_documental_analysis', 'value': "Sin Documentos"});
      }
      // if(this.status_medical_examen_filter.value)
      // {
      //     this.filters.push({'key': 'result_medical_exams-lk', 'value': this.status_medical_examen_filter.value});
      // }
      if (this.status_medical_examen_filter.value.indexOf('')=='-1'){// if (this.status_medical_examen_filter.value !== 'all' && this.status_medical_examen_filter.value !== '') {
          this.filters.push({'key': 'result_medical_exams-lk', 'value': this.status_medical_examen_filter.value});
      }
      if (this.start_admission_date_filter.value && this.end_admission_date_filter.value) {
          // let d = new Date(this.start_admission_date_filter.value);
          // d.setHours(0);
          // d.setMinutes(0);
          // d.setSeconds(0);
          // d.setMilliseconds(0);

          // const start_admission_date_filter = formatDate(d);

          // d = new Date(this.end_admission_date_filter.value);
          // d.setHours(23);
          // d.setMinutes(59);
          // d.setSeconds(59);
          // d.setMilliseconds(59);
          // const end_admission_date_filter = formatDate(d);
          const start_admission_date_filter = this.constDatesFilter(this.start_admission_date_filter.value, true,false);
          const end_admission_date_filter = this.constDatesFilter(this.end_admission_date_filter.value, false,false);
          if (start_admission_date_filter) {
              this.filters.push({'key': 'admission_date-min', 'value': start_admission_date_filter});
          }

          if (end_admission_date_filter) {
              this.filters.push({'key': 'admission_date-max', 'value': end_admission_date_filter});
          }
      }
      if(this.start_date_medical_appointment_filter.value && this.end_date_medical_appointment_filter.value){
          const start_date_medical_appointment_filter = this.constDatesFilter(this.start_date_medical_appointment_filter.value, true,true);
          const end_date_medical_appointment_filter = this.constDatesFilter(this.end_date_medical_appointment_filter.value, false,true);
          if (start_date_medical_appointment_filter) {
              this.filters.push({'key': 'date_medical_appointment-min', 'value': start_date_medical_appointment_filter});
          }

          if (end_date_medical_appointment_filter) {
              this.filters.push({'key': 'date_medical_appointment-max', 'value': end_date_medical_appointment_filter});
          }
      }
          

      if (this.sortHireToday && !this.only_attended) {
          this.sort = '-start_send_hiring_sign';
          const today = new Date();
          today.setHours(0);
          today.setMinutes(0);
          today.setSeconds(0);
          today.setMilliseconds(0);
          this.filters.push({'key': 'start_send_hiring_sign-min', 'value': formatDate(today.toISOString())});
          this.filters.push({'key': 'send_hiring_sign-lk', 'value': 1});
          this.per_page = 10;
      } else {
          this.per_page = 10;
          if(this.send_hiring_sign_filter.value)
          {
              this.filters.push({'key': 'send_hiring_sign-lk', 'value': this.send_hiring_sign_filter.value});
          }
      }

      if (this.sortHire && !this.only_attended) {
          this.sort = '-start_send_hiring_sign';
          this.filters.push({'key': 'send_hiring_sign-lk', 'value': 1});
      }

      if (this.params_id_requisition) {
          this.getSynergoCitationsByRequisitions(this.params_id_requisition);
      } else {
          this.getSynergoCitations();
      }
  }

  public activeAttendance(citation: Attendance, value?) {
      if (value === "0") {
          citation.attended_at = null;
      } else {
          citation.attended_at = formatDate(new Date().toISOString());
      }
      citation.attended = value;
      this.putAttendance(citation);
  }

  public sendDocumentalmanagementAttendance(citation: Attendance, value?) {
      citation.send_documental_management = value;
      if (value === "0") {
          citation.start_send_documental_management = null;
      } else {
          citation.start_send_documental_management = formatDate(new Date().toISOString());
      }
      citation.send_documental_management = value;
      this.putAttendance(citation);
  }
  
  public sendIncomeOrderAttendance(citation: Attendance, value?) {
      if (value === "0") {
          citation.start_send_income_order = null;
      } else {
          citation.start_send_income_order = formatDate(new Date().toISOString());
      }
      citation.send_income_order = value;
      this.putAttendance(citation);
  }

  public sendHiringSignAttendance(citation: Attendance, value?) {
      citation.send_hiring_sign = value;
      if (value === "0") {
          citation.start_send_hiring_sign = null;
          citation.manager_send_hiring_sign_by_id = null;
      } else {
          citation.start_send_hiring_sign = formatDate(new Date().toISOString());
      }
      this.putAttendance(citation);
  }
  public employeeSendHiringSignAttendance(value)
  {
      console.log("El nombre es: ");
      console.log(value);
      if(value.id)
      {
          console.log("El nombre..  ");
          // this.employeeSelected = value.id;
          this.selectCitation.manager_send_hiring_sign_by_id = value.id;
          //habilitar el botón de guardar
      }
      // else
      //     this.selectCitation.manager_send_hiring_sign_by_id = undefined;
  }
  public saveSendHiringSignAttendance()
  {
      this.sendHiringSignAttendance(this.selectCitation,"1");
      // this.employeeSelected = null;
      this.selectCitation = null;
      this.gestSignHireDialog = false;
  }
  public cancelSendHiringSignAttendance()
  {
      this.employeeSelected = null;
      this.gestSignHireDialog = false;
      this.selectCitation= null;
  }

  public sendHiringAttendance(citation: Attendance, value?) {
      if (value === 'No') {
          citation.start_send_hiring = null;
      } else {
          citation.start_send_hiring = formatDate(new Date().toISOString());
      }
      citation.send_hiring = value;
      this.putAttendance(citation);
  }

  public comeMedicalExamsAttendance(citation: Attendance, value?) {
      if (value === '0') {
          citation.date_come_medical_exams = null;
      } else {
          citation.date_come_medical_exams = formatDate(new Date().toISOString());
      }
      citation.come_medical_exams = value;
      this.putAttendance(citation);
  }

  public recruitAttendance(citation: Attendance) {
      if (!citation.recruited_accepted) {
          citation.recruited_accepted_at = null;
      } else {
          citation.recruited_accepted_at = formatDate(new Date().toISOString());
      }

      this.putAttendance(citation);
  }
  public saveMedicalExamsAttendance(citation: Attendance, date_medical_appointment: string, lab_medical_exams:string) {
      citation.date_medical_appointment = formatDate(new Date(date_medical_appointment).toISOString());
      citation.lab_medical_exams= lab_medical_exams;
      citation.start_medical_exams = formatDate(new Date().toISOString());
      this.putAttendance(citation);
      this.selectCitation = null;
      this.date_medical_appointment.setValue('');
      this.lab_medical_exams.setValue('');
      this.getMedicalAppointmentLaboratoryDialog = false;
      
  }

  public putAttendance(values: Attendance) {
      const param = {
          'attended': values.attended,
          'attended_at': values.attended_at,
          'recruited_accepted': values.recruited_accepted,
          'recruited_accepted_at': values.recruited_accepted_at,
          'recruited_at': values.recruited_at,
          'start_interview': values.start_interview,
          'end_interview': values.end_interview,
          'start_send_customer': values.start_send_customer,
          'end_send_customer': values.end_send_customer,
          'start_documental_analysis': values.start_documental_analysis,
          'end_documental_analysis': values.end_documental_analysis,
          'start_background_validation': values.start_background_validation,
          'end_background_validation': values.end_background_validation,
          'start_referencing': values.start_referencing,
          'end_referencing': values.end_referencing,
          'start_test': values.start_test,
          'end_test': values.end_test,
          'start_send_documental_management': values.start_send_documental_management,
          'send_documental_management': values.send_documental_management,
          'start_medical_exams': values.start_medical_exams,
          'end_medical_exams': values.end_medical_exams,
          'start_send_hiring': values.start_send_hiring,
          'send_hiring': values.send_hiring,
          'start_send_hiring_sign': values.start_send_hiring_sign,
          'send_hiring_sign': values.send_hiring_sign,
          'start_send_income_order': values.start_send_income_order,
          'send_income_order': values.send_income_order,
          'start_hire': values.start_hire,
          'end_hire': values.end_hire,
          'come_medical_exams': values.come_medical_exams,
          'date_come_medical_exams': values.date_come_medical_exams,
          'manager_send_hiring_sign_by_id': values.manager_send_hiring_sign_by_id,
          'date_medical_appointment': values.date_medical_appointment,
          'lab_medical_exams': values.lab_medical_exams,
      };
      if (values) {
          const promise = this.synergocitationService.updateSynergoCitation(values.id, param);
          this.promiseForm = promise.toPromise().then(
              response => {
                  this.translate.get('saved').subscribe((res: string) => {
                      this.msgs = [];
                      this.msgs.push( { severity: 'success', summary: res  } );
                  });
              },
              error => {
                  this.loading = false;
                  let msg = '';
                  this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                      this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                          JSON.parse(error._body).errors.forEach(element => {
                              if (element.source) {
                                  if (element.source.pointer) {
                                      this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                          msg = msg + res3 + ', ';
                                      });
                                  }
                              }
                          });
                          this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                      });
                  });
              }
          );
      }
  }

  public showDocumentation (citation) {

  }

  public showResultNewCandidate(msg) {
      this.msgs = [];
      this.msgs.push(msg);
  }

  public listView() {
      this.viewType = 'list';
  }

  public kanbanView() {
      if (this.params_id_requisition) {
          this.getSynergoCitationsByRequisitions(this.params_id_requisition);
          // this.getRecruitsByRequisitions(this.params_id_requisition);
      } else {
          this.getSynergoCitations();
          // this.getRecruits();
      }

      this.viewType = 'kanban';
  }

  public showEditCitation(citation: Attendance, type: string, event: string) {
      this.idEditRequisition = citation.requisition_id;
      this.idEditCitation = citation.id;
      this.citationEditCitation = citation;
      this.statusEditCitation = status;
      this.typeEditCitation = type;
      this.selectCitation = citation;

      if (event == 'end') {
          this.modViewDialog = true;
          this.editEventPart = event;
      }

      if (event == 'hiring_analyst') {
          this.editEventPart = event;
          this.modViewDialog = true;
      }

      switch (type) {
          case 'interview':
              if (event === 'start') {
                  citation.start_interview = formatDate(new Date().toISOString());
                  if (this.hasPermission('get citation allinone')) {
                      citation.start_send_customer = formatDate(new Date().toISOString());
                      citation.start_documental_analysis = formatDate(new Date().toISOString());
                      citation.start_referencing = formatDate(new Date().toISOString());
                      citation.start_test = formatDate(new Date().toISOString());
                      citation.start_send_hiring = formatDate(new Date().toISOString());
                      citation.start_send_hiring_sign = formatDate(new Date().toISOString());
                      citation.start_send_income_order = formatDate(new Date().toISOString());
                      citation.start_send_documental_management = formatDate(new Date().toISOString());
                  }
                  this.putAttendance(citation);
              }
          break;
          case 'send_customer':
              if (event === 'start') {
                  citation.start_send_customer = formatDate(new Date().toISOString());
                  this.putAttendance(citation);
              }
          break;
          case 'documental_analysis':
              if (event === 'start') {
                  citation.start_documental_analysis = formatDate(new Date().toISOString());
                  this.putAttendance(citation);
              }
          break;
          case 'referencing':
              if (event === 'start') {
                  citation.start_referencing = formatDate(new Date().toISOString());
                  this.putAttendance(citation);
              }
          break;
          case 'background_validation':
              if (event === 'start') {
                  citation.start_background_validation = formatDate(new Date().toISOString());
                  this.putAttendance(citation);
              }
          break;
          case 'test':
              if (event === 'start') {
                  citation.start_test = formatDate(new Date().toISOString());
                  this.putAttendance(citation);
              }
          break;
          case 'medical_exams':
              if (event === 'start') {
                  citation.start_medical_exams = formatDate(new Date().toISOString());
                  this.putAttendance(citation);
              }
          break;
          case 'hire':
              if (event === 'start') {
                  citation.start_hire = formatDate(new Date().toISOString());
                  this.putAttendance(citation);
              }
          break;
      }
  }

  public hiddenEditCitation() {
      if (this.params_id_requisition) {
          this.getSynergoCitationsByRequisitions(this.params_id_requisition);
          // this.getRecruitsByRequisitions(this.params_id_requisition);
      } else {
          this.getSynergoCitations();
          // this.getRecruits();
      }
      this.modViewDialog = false;
  }

  public hasPermission(permission) {
      return this.hasPermissionService.hasPermission(permission);
  }
  public hasRole(rol){
      var r: boolean=false; 
      var role = JSON.parse(localStorage.getItem('profile')).roles[0].id;
      if(role == rol){ 
          r = true;
      }
      return (r);
  }
  public viewDialogCandidate(candidate: Candidate, sticky: boolean) {
      this.selectCandidate = candidate;
      this.modViewDialogCandidate = true;
      this.sticky = sticky;
  }
  public viewDialogWhatsapp(candidate: Candidate, sticky: boolean) {
       this.selectCandidate = candidate;
      this.mobile_send.setValue(this.selectCandidate.mobile);
      this.message_send.setValue("Hola estimado(a) "+this.selectCandidate.name);
      this.modViewDialogWhatsapp = true;
      this.sticky = sticky;
  }

  public viewHideDialogCandidate() {
      if (!this.sticky) {
          this.modViewDialogCandidate = false;
      }
  }

  public cancelCandidate (res) {
      this.selectCandidate = null;
      this.modViewDialogCandidate = false;
  }

  public filterGeneral() {
      this.sortHireToday = false;
      this.sortHire = false;
      this.page = 1;
      this.first = 0;
      this.filter(true);
  }

  public filterSortHireToday() {
      this.sortHireToday = true;
      this.sortHire = false;
      this.page = 1;
      this.first = 0;
      this.filter(true);
  }

  public filterSortHireAll() {
      this.sortHireToday = false;
      this.sortHire = true;
      this.page = 1;
      this.first = 0;
      this.filter(true);
  }

  public showExportDialog() {
      this.modExportDialog = true;
  }

  public cancelExport() {
      this.modExportDialog = false;
  }
  public cancelTransfer(){
      this.modViewDialogExchangeCitation=false;
      this.requisitionTrasnferOk=false;
      this.requisitionTrasnfer=[];
      this.resultSelectCitationsTransf=[];
      this.lengthresultSelectCitationsTransf=0;
      this.showrequisitionTransfer=false;
  }

  public showRecruitmentDialog() {
      this.modRecruitmentDialog = true;
  }

  public cancelRecruitment() {
      this.modRecruitmentDialog = false;
      this.reloadInterval();
  }

  public showImportDialog() {
      this.modImportDialog = true;
  }

  public cancelImport() {
      this.modImportDialog = false;
  }

  
  public showDocumentationDialog(citation, type) {

      this.selectCitation = citation;
      this.uploadedAttachment = [];
      this.selectCitationType = type;
      var citation_id = citation.id;
      var profile_survey_id = citation.profile_survey_id;
  
      this.contractService.getDocumentProfileSurveyUnionCheckList(citation_id,profile_survey_id,this.selectCitationType).toPromise().then(        response => {
              this.listDocuments = [];
              this.result = response.json();
              console.log('tipo : ' + typeof(this.result));
              let list = [...this.listDocuments];
              this.result.data.forEach(element => {
                  if(element.document_profile_survey.length>0){
                      for(var x=0;x<element.document_profile_survey.length;x++){
                          if(element.document_profile_survey[x].expires_at) element.document_profile_survey[x].expires_at= new Date(element.document_profile_survey[x].expires_at);
                      }
                  }
                  if (element.type == type) {
                      list.push(element);
                  }
              });
              this.listDocuments = list;
              this.modViewDialogDocumentation = true;
              this.loading_upload=false;
          },
          error => {
              this.msgs = [];
              this.msgs.push( { severity: 'error', summary: 'error' } );
          }
      );

      // this.getDocumentHV(1);
      this.getDocumentHV(citation.candidate_id);
          
    }

  public cancelDocumentation() {
      this.selectCitation = undefined;
      this.modViewDialogDocumentation = false;
  }

  public onUploadImportFile(event: any) {
      this.uploadedImportFile = [];
      for (const file of event.srcElement.files) {
          this.uploadedImportFile.push(file);
      }
      if (event.target.files && event.target.files[0]) {
          const reader = new FileReader();
          reader.onload = () => {
            this.prewiewImportFile = reader.result;
          };
          reader.readAsDataURL(event.target.files[0]);
      }
  }

  public updateImportFile(event: any) {
      this.translate.get('uploading').subscribe((res: string) => {
          this.notificationsService.growlNotify('info', res + '...');
      });

      this.uploadedImportFile = [];
      for (const file of event.files) {
          this.uploadedImportFile.push(file);
      }

      this.promiseImportFile = this.uploadFilesService.updateFileImportCitation(this.uploadedImportFile).toPromise().then(
          response => {
              this.translate.get('saved').subscribe((res: string) => {
                  this.msgs = [];
                  this.msgs.push( { severity: 'success', summary: res  } );
              });
              // this.getProfile();
              // this.avatar = this.prewiewImportFile;
          },
          error => {
              let msg = '';
              this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                  this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                      JSON.parse(error._body).errors.forEach(element => {
                          if (element.source) {
                              if (element.source.pointer) {
                                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                      msg = msg + res3 + ', ';
                                  });
                              }
                          }
                      });
                      this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                  });
              });
          }
      );
  }

  public exportReportExcel(values) {
      let d = new Date(values.f4_date_start);
      d.setHours(0);
      d.setMinutes(0);
      d.setSeconds(0);
      d.setMilliseconds(0);

      const f4_date_start = formatDate(d);

      d = new Date(values.f4_date_end);
      d.setHours(23);
      d.setMinutes(59);
      d.setSeconds(59);
      d.setMilliseconds(59);
      const f4_date_end = formatDate(d);

      let url = this.apiUrl + '/citations/excel?' +
      'token=' + localStorage.getItem('token') +
      '&_page=1&_limit=100000&_sort=venue_id,company_id&';

      if (values.f4_venue_id) {
          url = url + 'venue_id-in=' + values.f4_venue_id + '&';
      }

      if (values.f4_company_id) {
          url = url + 'company_id-in=' + values.f4_company_id.id + '&';
      }

      if (values.f4_status_filter !== 'all' && values.f4_status_filter !== '') {
          url = url + 'status-in=' + values.f4_status_filter + '&';
      }

      if (values.f4_export_type_filter) {
          url = url + 'type=' + values.f4_export_type_filter.value + '&';
      }

      if (values.f4_export_type_filter) {
          if (values.f4_export_type_filter.value === 'Reporte Citación - Contratado Diario') {
              if (f4_date_start) {
                  url = url + 'end_hire-min=' + f4_date_start + '&';
              }

              if (f4_date_end) {
                  url = url + 'end_hire-max=' + f4_date_end + '&';
              }
          }
          else if (values.f4_export_type_filter.value === 'Reporte Citación - Documentación' ||
                  values.f4_export_type_filter.value === 'Reporte Citación - Contratado por Fecha Ingreso' ||
                  values.f4_export_type_filter.value === 'Reporte Citación - Fecha de ingreso') {
                  if (f4_date_start) {
                      url = url + 'admission_date-min=' + f4_date_start + '&';
                  }

                  if (f4_date_end) {
                      url = url + 'admission_date-max=' + f4_date_end + '&';
                  }
          } 
          else {
              if (f4_date_start) {
                  url = url + 'created_at-min=' + f4_date_start + '&';
              }

              if (f4_date_end) {
                  url = url + 'created_at-max=' + f4_date_end + '&';
              }
          }
      } else {
          if (f4_date_start) {
              url = url + 'created_at-min=' + f4_date_start + '&';
          }

          if (f4_date_end) {
              url = url + 'created_at-max=' + f4_date_end + '&';
          }
      }

      window.open(url, '_blank');
  }

  getCandidate(query?: string) {
      this.candidateService.getCandidate(this.page, this.per_page, undefined, query).toPromise().then(
          response => {
              this.candidate = response.json().data;
              if (response.json().meta.total > response.json().meta.total_filtered) {
                  this.totalRecords = response.json().meta.total_filtered;
              } else {
                  this.totalRecords = response.json().meta.total;
              }
          },
          error => {
              let msg = '';
              this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                  this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                      JSON.parse(error._body).errors.forEach(element => {
                          if (element.source) {
                              if (element.source.pointer) {
                                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                      msg = msg + res3 + ', ';
                                  });
                              }
                          }
                      });
                      this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                  });
              });
          }
      );
  }

  public onUploadFileDocumentProfileSurvey(event: any, citation, item) {
      console.log (event);
      for (const file of event.srcElement.files) {
          this.uploadedAttachment[item.id] = file
      }
      if (event.target.files && event.target.files[0]) {
          const reader = new FileReader();
          reader.onload = () => {
            this.prewiewFileAttachment[item.id] = reader.result;
          };
          reader.readAsDataURL(event.target.files[0]);
      }
  }

  public updateAttachmentDocumentProfileSurvey(event, citation, checklist_profile_survey) {
      this.loading_upload=true;
      this.translate.get('uploading').subscribe((res: string) => {
          this.notificationsService.growlNotify('info', res + '...');
      });

      let id;
      if (checklist_profile_survey.document_profile_survey) {
          if (checklist_profile_survey.document_profile_survey.length > 0) {
            id = checklist_profile_survey.document_profile_survey[0].id;
          }
      }

      let uploadedAttachment = [];
      for (const file of event.files) {
          uploadedAttachment.push(file);
      }

      this.promiseAttachment = this.uploadFilesService.updateAttachmentDocumentProfileSurvey(uploadedAttachment, id, citation.id, citation.profile_survey_id, checklist_profile_survey.id, checklist_profile_survey.list_doc_profile_survey_id).toPromise().then(
          response => {
              this.uploadedAttachment[response.json().checklist_profile_survey_id] = {'name': 'Archivo Adjunto  ', 'id': response.json().id};
              this.translate.get('saved').subscribe((res: string) => {
                  this.notificationsService.growlNotify('success', res);
                  this.showDocumentationDialog(this.selectCitation,this.selectCitationType);
              });
          },
          error => {
              this.loading_upload=false;
              let msg = '';
              this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                  this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                      JSON.parse(error._body).errors.forEach(element => {
                          if (element.source) {
                              if (element.source.pointer) {
                                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                      msg = msg + res3 + ', ';
                                  });
                              }
                          }
                      });
                      this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                  });
              });
          }
      );
  }

  public deleteAttachmentDocumentProfileSurvey(id) {
      this.promiseAttachment = this.uploadFilesService.deleteAttachmentDocumentProfileSurvey(id).toPromise().then(
          response => {
              this.translate.get('saved').subscribe((res: string) => {
                  this.notificationsService.growlNotify('success', res);
                  this.showDocumentationDialog(this.selectCitation,this.selectCitationType);
              });
              const index = this.findElement(this.uploadedAttachment, id);
              if (index > -1) {
                  this.uploadedAttachment.splice(index, 1);
              }                
              console.log(this.uploadedAttachment);
          },
          error => {
              let msg = '';
              this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                  this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                      JSON.parse(error._body).errors.forEach(element => {
                          if (element.source) {
                              if (element.source.pointer) {
                                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                      msg = msg + res3 + ', ';
                                  });
                              }
                          }
                      });
                      this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                  });
              });
          }
      );
  }

  public gotoAttachment(id) {
      window.open(this.apiUrl + '/list-document-profile-surveis/' + id + '/attachment' + '?token=' + localStorage.getItem('token'), '_blank');
  }

  public gotoAttachmentDocumentProfileSurvey(id) {
      window.open(this.apiUrl + '/document-profile-surveis/' + id + '/attachment' + '?token=' + localStorage.getItem('token'), '_blank');
  }

  public downloadAllFiles(id) {
      window.open(this.apiUrl + '/document-profile-surveis/' + id + '/zip' + '?token=' + localStorage.getItem('token'), '_blank');
  }
  
  printCitation(citation) {
      window.open(this.apiUrl + '/citations/' + citation.id + '/pdf?token=' + localStorage.getItem('token'), '_blank');
  }

  public findElement (list, search) {
      let find = -1;
      let itera = 0;
      list.forEach(element => {
          if (element.id === search) {
              find = itera;
          }
          itera++;
      });
      return find;
  }

  // percentDocContract(citation){
  //     let percent = 0;
  //     let totalContract = 0;
  //     let totalContractUpload = 0;
  //     citation.profile_survey.checklist_profile_survey.forEach(element => {
  //         if (element.list_doc_profile_survey.type === 'Contratación' && element.required) {
  //             totalContract = totalContract + 1;
  //             const index = this.findListDocumentProfileSurvey(citation.document_profile_survey, element.list_doc_profile_survey.id);
  //             if (index > -1) {
  //                 totalContractUpload = totalContractUpload + 1;
  //             }                
  //         }
  //     });
  //     percent = Math.floor(totalContractUpload * 100 / totalContract);
  //     return percent;
  // }
  percentDocContract(citation){
      let percent = 0;
      let totalContract = 0;
      let totalContractUpload = 0;
      let docsUpload=citation.document_profile_survey;
      let docsChecklist=citation.profile_survey.checklist_profile_survey;
      /*docsUpload.forEach(element => {
          // pos = myArray.map(function(e) { return e.hello; }).indexOf('stevie');
          docsChecklist.forEach(element2=>{
              if (element.list_profile_survey_id == element2.list_id ) {
                  totalContractUpload = totalContractUpload + 1;
                                  
              }
          })
          
      });*/
    docsChecklist.forEach(element2=>{
          let docrepet=false;
      docsUpload.forEach(element => {
    if (element.list_profile_survey_id == element2.list_id && !docrepet) {
                      totalContractUpload = totalContractUpload + 1;
                          docrepet=true;
                        //break;            
                }
      })
    });
      totalContract = docsChecklist.length;
      percent = Math.floor(totalContractUpload * 100 / totalContract);
      return percent;
  }

  public findListDocumentProfileSurvey (list, search) {
      let find = -1;
      let itera = 0;
      list.forEach(element => {
          if (element.list_profile_survey_id === search) {
              find = itera;
          }
          itera++;
      });
      return find;
  }

  openWhatsapp(event) {
      window.open('https://api.whatsapp.com/send?phone=' + '57' + event.mobile_send + '&text=' + event.message_send, '_blank');
  }

  showSidebarJustification(citation) {
      this.selectCitation = citation;
      this.getCitationJustification (this.selectCitation.id);
      this.getDataCustomerGuide(Number(this.selectCitation.company_id));
      this.displaySidebarJustification = true;
      //this.reloadListKanban(citation);
  }

  closeSidebarJustification() {
      // this.instruction.setValue('dd');
      // this.justification.setValue('dd');
      this.form2.reset();
      this.form8.reset();
      // this.form8.markAsTouched();
      
      this.selectCitation = undefined;
      this.displaySidebarJustification = false;
  }
  public newCitationJustification(values) {
      const param = {
          justification: values.justification,
          citation_id: this.selectCitation.id
      };
      // if (values && this.form.valid)
      if (values) {
          const promise = this.attendanceJustificationService.newAttendanceJustification(this.selectCitation.id, param);

          this.promiseForm = promise.toPromise().then(
              response => {
                  //this.getCitationJustification(this.selectCitation.id);
                  this.translate.get('saved').subscribe((res: string) => {
                      this.msgs = [];
                      this.msgs.push( { severity: 'success', summary: res  } );
                  });
                  this.closeSidebarJustification();
              },
              error => {
                  this.msgs = [];
                  this.msgs.push( { severity: 'error', summary: 'Error' } );
              }
          );
      }
  }
  public editFirstDayCustomerGuide(values) {
      
      let id=this.informationCustomerGuide[0].customer_guides_id;
      const param = {
          first_day_instruction: values.instruction
      };
      // if (values && this.form.valid)
      if (values) {
          const promise = this.customerGuideService.editFirstDayCustomerGuide(id,param);

          this.promiseForm = promise.toPromise().then(
              response => {
                  this.translate.get('saved').subscribe((res: string) => {
                      this.msgs = [];
                      this.msgs.push( { severity: 'success', summary: res  } );
                  });
                  this.closeSidebarJustification();
              },
              error => {
                  this.msgs = [];
                  this.msgs.push( { severity: 'error', summary: 'Error' } );
              }
          );
      }
  }
  // public checkValidation(field){
  //     if(field=='')
  //         return false;
  //     return true;    
  // }
  getCitationJustification (id: number) {
      this.attendanceJustificationService.getAttendanceJustificationAll(id).toPromise().then(
          response => {
              
              this.listCitationJustification = response.json().data;//this.edit1.attendance_justification = response.json().data[0].citation_justification;
                  this.form2.reset();
                  this.form8.reset();
          },
          error => {
              this.msgs = [];
              this.msgs.push( { severity: 'error', summary: 'error' } );
          }
      );
  }
  getDataCustomerGuide(company_id: number){
      this.customerGuideService.infoCustomerGuideCitation(company_id).toPromise().then(
          response => {
              
              this.informationCustomerGuide = response.json();
                  this.form8.reset();  
                  this.form2.reset();               
                             
          },
          error => {
              this.msgs = [];
              this.msgs.push( { severity: 'error', summary: 'error' } );
          }
      );
  }
  onRowSelect(event) {
      console.log(this.selectCitationsTransf);
      this.showbuttonExchangeCitation=true;//this.exchangeCitationsShowDialog();
  }

  onRowUnselect(event) {
      console.log(this.selectCitationsTransf);
      if(this.selectCitationsTransf.length>0)
          this.showbuttonExchangeCitation=true;//this.exchangeCitationsShowDialog();
      else
          this.showbuttonExchangeCitation=false;        
  }

  onHeaderCheckboxToggle(event){
      // + event.originalEvent: Browser event
      // + event.checked: State of the header checkbox
      if(event.checked){
          console.log(this.selectCitationsTransf);
          this.showbuttonExchangeCitation=true;//this.exchangeCitationsShowDialog();
      }
      else
          this.showbuttonExchangeCitation=false;//    
  }
  exchangeCitationsShowDialog() {
      this.modViewDialogExchangeCitation=true;//this.showbuttonExchangeCitation=true;//
      
  }
  public getRequisitionTransfer(requisition_id){
      //let requisition_id;
      if(requisition_id)//if(this.requisition_id_transfer.value)
      {
          this.loadingShowTransfReq=true;
          //requisition_id=this.requisition_id_transfer.value;
          this.synergocitationService.infoSynergoRequisition(requisition_id).toPromise().then(
              response=>{
                  this.loadingShowTransfReq=false;
                  this.showrequisitionTransfer=true;
                  this.requisitionTrasnfer= response.json().data;
                  if(this.requisitionTrasnfer[0].status!="Abierto" && this.requisitionTrasnfer[0].status!="En Proceso" && this.requisitionTrasnfer[0].status!="Backup"){
                      this.showrequisitionTransferClose=true;
                      this.requisitionTrasnferOk = false;
                  
                  }    
                  else{
                      this.requisitionTrasnferOk = true;
                      this.showrequisitionTransferClose= false;
                  }        
              },
              error=>{
                  this.loadingShowTransfReq=false;
                  this.requisitionTrasnferOk = false;
                  this.showrequisitionTransfer=false;
                  this.showrequisitionTransferClose= false;
                  
              }
          );
      }
  }
  
  public RequisitionsTransfer(values){
      var selectCitationsTransfId=[];
      if(this.requisitionTrasnferOk){
          for(let i=0;i<this.selectCitationsTransf.length;i++)
              selectCitationsTransfId.push(this.selectCitationsTransf[i].id);
               
          console.log("El Id de la requisición es:" + this.requisitionTrasnfer[0].id + " y las operaciones son: "+selectCitationsTransfId);
          console.log(JSON.stringify(selectCitationsTransfId));
          let param = {'citationsTransfer': selectCitationsTransfId,
                       'profileSurveyRequisition':   this.requisitionTrasnfer[0].profile_survey_id,
                       'companyRequisition':   this.requisitionTrasnfer[0].company_id
                      };
          if(selectCitationsTransfId.length>0)
          {
              this.synergocitationService.citationsTransferService(this.requisitionTrasnfer[0].id,param).toPromise().then(
                  response=>{
                      // this.showrequisitionTransfer=true;
                      this.resultSelectCitationsTransf= response.json().data;
                      this.lengthresultSelectCitationsTransf = this.resultSelectCitationsTransf.length;
                      console.log("Listo!!");
                  },
                  error=>{
                      // this.showrequisitionTransfer=false;
                      alert("Error");
                      this.lengthresultSelectCitationsTransf=0;
                  }
              );
          }
          else{
              alert("Citacion(es) ya está(n) agregada(a) a la requisición");
              console.log("Citaciones no validas para anexar");
          }
      }
  }
  public showUploadDialog() {
      this.modViewDialogUploadCitationExc = true;
  }
  
  public cancelUpload() {
      this.modViewDialogUploadCitationExc = false;
      this.requisitionTrasnferOk=false;
      this.requisitionTrasnfer=[];
      this.resultSelectCitationsTransf=[];
      this.lengthresultSelectCitationsTransf=0;
      this.showrequisitionTransfer=false;
  }
  public attachmentUploadCitations(event) {
      this.loading_upload=true;
      this.translate.get('uploading').subscribe((res: string) => {
          this.notificationsService.growlNotify('info', res + '...');
      });

      
      let uploadedAttachment = [];
      for (const file of event.files) {
          uploadedAttachment.push(file);
      }
          
      this.promiseAttachment = this.uploadFilesService.attachmentUploadCitations(uploadedAttachment).toPromise().then(
          response => {
              this.loading_upload=false;
              this.citationsUploadResult=response.json().data;
              this.citationsUploadResultStatus =response.status;
              this.lengthCitationsUploadResult= this.citationsUploadResult.length;
              console.log("Documento subido excel");
              this.translate.get('saved').subscribe((res: string) => {
                  this.notificationsService.growlNotify('success', res);
              });
          },
          error => {
              this.loading_upload=false;
              let msg = '';
              this.citationsUploadResult = error._body;
              this.citationsUploadResultStatus = error.status;
              this.lengthCitationsUploadResult= 0;
              this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                  this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                      JSON.parse(error._body).errors.forEach(element => {
                          if (element.source) {
                              if (element.source.pointer) {
                                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                      msg = msg + res3 + ', ';
                                  });
                              }
                          }
                      });
                      this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                  });
              });
          }
      );
  }
  public downloadTemplateCitations()
  {
      window.open(this.apiUrl + '/document-profile-surveis/downloadTemplateCitations'+ '?token=' + localStorage.getItem('token'));
  }

  getDocumentHV(id) {
      this.listDocumentsHV=[];
      this.candidateService.getDocumentHV(id).toPromise().then(
          response => {
              console.log(response)
              this.listDocumentsHV = response.json().data;
          },
          error => {
              console.log(error)
              // var status = error.status;
              
              // if(status != 404)
              // this.translate.get('error files HV').subscribe((res: string) => {
              //     this.notificationsService.growlNotify('error', res);
              // });
          }
      );
  }
  goUrl(url) {
      window.location.href=url;
  }
  downloadAllFilesHV(citation_id,profile_survey_id,dataHvJs){
      this.copyHV=true;
      var dataHv = new Array();
      if(dataHvJs== undefined)
          dataHv= this.listDocumentsHV;
      else
          dataHv.push(dataHvJs);
      let param ={
          "citation_id" : citation_id,
          "profile_survey_id" : profile_survey_id,
          "data": dataHv
      };        
      this.translate.get('Copying ...').subscribe((res: string) => {
          this.notificationsService.growlNotify('info', res);
      });    
      this.synergocitationService.docsFromHVtoKaizenService(param).toPromise().then(
          response =>{
              console.log(response);
              let msg= JSON.stringify(response); 
              this.translate.get((<any>response)._body).subscribe((res1: string) => {
                  this.notificationsService.growlNotify('success', res1 );
              });
              this.showDocumentationDialog(this.selectCitation,this.selectCitationType);
              this.copyHV=false;
          },
          error =>{
              console.log(error);
              this.translate.get(JSON.parse(error._body)).subscribe((res: string) => {
                  this.notificationsService.growlNotify('error', res);
              });
              this.copyHV=false;
          }
      );
  }
  changesendHiringSignAttendance(citation: Attendance, value?)
  {
      this.gestSignHireDialog=true;
      this.selectCitation=citation;
          
  }
  medicalAppointmentLaboratoryDialogAttendance(citation: Attendance, value?)
  {
      this.getMedicalAppointmentLaboratoryDialog=true;
      this.selectCitation=citation;
          
  }
  public cancelmedicalAppointmentLaboratoryAttendance()
  {
      this.date_medical_appointment.setValue('');
      this.lab_medical_exams.setValue('');
      this.getMedicalAppointmentLaboratoryDialog = false;
      this.selectCitation= null;
  }
  constDatesFilter(dateFilter: any, zero: boolean, gmt: boolean){
      let d = new Date(dateFilter);
      if(zero)
      {
          d.setHours(0);
          d.setMinutes(0);
          d.setSeconds(0);
          d.setMilliseconds(0);
      }
      else
      {    
          d.setHours(23);
          d.setMinutes(59);
          d.setSeconds(59);
          d.setMilliseconds(59);
      }
      if(gmt)
          return d.toISOString();
      return formatDate(d);
  }
  getDiffColumn(value,value2) {
      if ((value == '' || value == null) || (value2 == '' || value2 == null))
          return '';   
      let dateStart = new Date(value);
      let dateEnd = new Date(value2);
      var diff = (dateEnd.getTime() - dateStart.getTime())/1000 ;
      // calculate (and subtract) whole days
      var days = Math.floor(diff / 86400);
      diff -= days * 86400;

      // calculate (and subtract) whole hours
      var hours = Math.floor(diff / 3600) % 24;
      diff -= hours * 3600;

      // calculate (and subtract) whole minutes
      var minutes = Math.floor(diff / 60) % 60;
      diff -= minutes * 60;

      // what's left is seconds
      var seconds = diff % 60;  // in theory the modulus is not required
      var x="";
      if(days>0)
          x+=days+" día(s), ";
      if(minutes>0 || days>0 )     
          x+=minutes+" minutos(s), ";
      // if(seconds>0)     
          x+=seconds+" segundos(s) ";
      return x;        
  }
  saveExpiresAt(item)//   saveExpiresAt(expires,doc_item_id,expire_at)
  {
      let item_t=item;
      item_t.expires_at= formatDate(item_t.expires_at.toISOString());
      var doc_item_id= item_t.id;
      console.log(item_t);
      this.promiseAttachment = this.documentProfileSurveyService.updateDocumentProfileSurvey(doc_item_id, item_t).toPromise().then(
          response => {
              this.translate.get('saved').subscribe((res: string) => {
                  this.notificationsService.growlNotify('success', res);
              });
          },
          error =>{
              let msg = '';
              this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                  this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                      JSON.parse(error._body).errors.forEach(element => {
                          if (element.source) {
                              if (element.source.pointer) {
                                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                      msg = msg + res3 + ', ';
                                  });
                              }
                          }
                      });
                      this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                  });
              });
          }
      );
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/synergo/synergo-citations/synergo-citations.component.ts